import React, { useMemo } from 'react'
import ExcelDataGrid from '../common/ExcelDataGrid'

const SeniorCitizens194PTable = ({ seniorCitizenData, onSeniorCitizenDataChange }) => {

    const columns = useMemo(() => [
        { key: 'seniorCitizenPan', label: 'PAN of Specified Senior Citizen', width: '150px', type: 'text', required: true },
        { key: 'seniorCitizenName', label: 'Name of Specified Senior Citizen', width: '200px', type: 'text', required: true },
        {
            key: 'category',
            label: 'Category (Senior/Super Senior)',
            width: '180px',
            type: 'select',
            options: [
                { value: 'S', label: 'S - Senior Citizen' },
                { value: 'O', label: 'O - Super Senior Citizen' }
            ]
        },
        {
            key: 'regime115BAC',
            label: 'Tax Regime (115BAC)',
            width: '200px',
            type: 'select',
            options: [
                { value: 'N', label: 'No' },
                { value: 'Y', label: 'Yes' }
            ]
        },
        { key: 'grossPension17_1ii', label: 'Gross Pension (Sec 17(1)(ii))', width: '180px', type: 'number' },
        { key: 'ded16ia', label: '16(ia)', width: '100px', type: 'number' },
        { key: 'ded16iii', label: '16(iii)', width: '100px', type: 'number' },
        { key: 'totalDed16', label: 'Gross Total Deduction u/s 16', width: '180px', type: 'number', readOnly: true },
        { key: 'salariesIncome', label: 'Income under "Salaries" (396-399)', width: '180px', type: 'number' },
        { key: 'interestIncome', label: 'Interest Income (Other Sources)', width: '180px', type: 'number' },
        { key: 'grossTotalIncome', label: 'Gross Total Income (400+401)', width: '180px', type: 'number', readOnly: true },
        { key: 'lastGrossTotalIncome', label: 'Last Gross Total Income (Verification)', width: '180px', type: 'number' },
        { key: 'sec80C_Gross', label: '80C Gross', width: '100px', type: 'number' },
        { key: 'sec80C', label: '80C Deductible', width: '110px', type: 'number' },
        { key: 'sec80CCC_Gross', label: '80CCC Gross', width: '100px', type: 'number' },
        { key: 'sec80CCC', label: '80CCC Deductible', width: '110px', type: 'number' },
        { key: 'sec80CCD1_Gross', label: '80CCD(1) Gross', width: '115px', type: 'number' },
        { key: 'sec80CCD1', label: '80CCD(1) Ded', width: '110px', type: 'number' },
        { key: 'sec80CCD1B_Gross', label: '80CCD(1B) Gross', width: '115px', type: 'number' },
        { key: 'sec80CCD1B', label: '80CCD(1B) Ded', width: '110px', type: 'number' },
        { key: 'sec80D_Gross', label: '80D Gross', width: '100px', type: 'number' },
        { key: 'sec80D', label: '80D Deductible', width: '110px', type: 'number' },
        { key: 'sec80E_Gross', label: '80E Gross', width: '100px', type: 'number' },
        { key: 'sec80E', label: '80E Deductible', width: '110px', type: 'number' },
        { key: 'sec80G_Gross', label: '80G Gross', width: '100px', type: 'number' },
        { key: 'sec80G_Qual', label: '80G Qualify', width: '110px', type: 'number' },
        { key: 'sec80G', label: '80G Deductible', width: '110px', type: 'number' },
        { key: 'sec80TTB_Gross', label: '80TTB Gross', width: '100px', type: 'number' },
        { key: 'sec80TTB_Qual', label: '80TTB Qualify', width: '115px', type: 'number' },
        { key: 'sec80TTB', label: '80TTB Deductible', width: '115px', type: 'number' },
        { key: 'sec80DD_Gross', label: '80DD Gross', width: '100px', type: 'number' },
        { key: 'sec80DD_Qual', label: '80DD Qualify', width: '100px', type: 'number' },
        { key: 'sec80DD', label: '80DD Deductible', width: '110px', type: 'number' },
        { key: 'sec80EE_Gross', label: '80EE Gross', width: '100px', type: 'number' },
        { key: 'sec80EE_Qual', label: '80EE Qualify', width: '100px', type: 'number' },
        { key: 'sec80EE', label: '80EE Deductible', width: '110px', type: 'number' },
        { key: 'sec80EEA_Gross', label: '80EEA Gross', width: '110px', type: 'number' },
        { key: 'sec80EEA_Qual', label: '80EEA Qualify', width: '115px', type: 'number' },
        { key: 'sec80EEA', label: '80EEA Deductible', width: '120px', type: 'number' },
        { key: 'sec80GG_Gross', label: '80GG Gross', width: '100px', type: 'number' },
        { key: 'sec80GG_Qual', label: '80GG Qualify', width: '100px', type: 'number' },
        { key: 'sec80GG', label: '80GG Deductible', width: '110px', type: 'number' },
        { key: 'sec80GGC_Gross', label: '80GGC Gross', width: '110px', type: 'number' },
        { key: 'sec80GGC_Qual', label: '80GGC Qualify', width: '115px', type: 'number' },
        { key: 'sec80GGC', label: '80GGC Deductible', width: '120px', type: 'number' },
        { key: 'sec80U_Gross', label: '80U Gross', width: '100px', type: 'number' },
        { key: 'sec80U_Qual', label: '80U Qualify', width: '100px', type: 'number' },
        { key: 'sec80U', label: '80U Deductible', width: '110px', type: 'number' },
        { key: 'secOthers_Gross', label: 'Others Gross', width: '100px', type: 'number' },
        { key: 'secOthers_Qual', label: 'Others Qualify', width: '110px', type: 'number' },
        { key: 'secOthers', label: 'Others Deductible', width: '110px', type: 'number' },
        { key: 'ded80C_CCC_CCD1', label: 'Total Deduction u/s 80C, 80CCC, 80CCD(1)', width: '220px', type: 'number', readOnly: true },
        { key: 'aggChapterVIA', label: 'Aggregate Deduction under Chapter VI-A', width: '220px', type: 'number', readOnly: true },
        { key: 'totalTaxableIncome', label: 'Total Taxable Income (402-426)', width: '200px', type: 'number', readOnly: true },
        { key: 'incomeTax', label: 'Tax on Total Income', width: '150px', type: 'number' },
        { key: 'rebate87A', label: 'Rebate u/s 87A', width: '130px', type: 'number' },
        { key: 'surcharge', label: 'Surcharge', width: '130px', type: 'number' },
        { key: 'cess', label: 'Health and Education Cess', width: '180px', type: 'number' },
        { key: 'taxPayable', label: 'Tax Payable [428+430+(431-429)]', width: '180px', type: 'number', readOnly: true },
        { key: 'relief89', label: 'Relief u/s 89', width: '130px', type: 'number' },
        { key: 'netTaxPayable', label: 'Net Tax Payable', width: '150px', type: 'number', readOnly: true }
    ], []);

    const handleDataChange = (newData) => {
        const calculatedData = newData.map(row => {
            const r = { ...row };

            // Logic to calculate total deduction u/s 16
            r.totalDed16 = parseFloat(r.ded16ia || 0) + parseFloat(r.ded16iii || 0);

            // Basic calculations based on field labels
            r.grossTotalIncome = parseFloat(r.salariesIncome || 0) + parseFloat(r.interestIncome || 0);

            // Logic to calculate Chapter VI-A deductions
            r.ded80C_CCC_CCD1 = parseFloat(r.sec80C || 0) + parseFloat(r.sec80CCC || 0) + parseFloat(r.sec80CCD1 || 0);

            r.aggChapterVIA = r.ded80C_CCC_CCD1 +
                parseFloat(r.sec80CCD1B || 0) +
                parseFloat(r.sec80D || 0) +
                parseFloat(r.sec80E || 0) +
                parseFloat(r.sec80G || 0) +
                parseFloat(r.sec80TTB || 0) +
                parseFloat(r.sec80DD || 0) +
                parseFloat(r.sec80EE || 0) +
                parseFloat(r.sec80EEA || 0) +
                parseFloat(r.sec80GG || 0) +
                parseFloat(r.sec80GGC || 0) +
                parseFloat(r.sec80U || 0) +
                parseFloat(r.secOthers || 0);

            r.totalTaxableIncome = r.grossTotalIncome - r.aggChapterVIA;

            // Tax Payable = Tax + Surcharge + Cess - Rebate
            // Note: The formula in image [428 + 430 +(431-429)] is abbreviated. 
            // 428: Tax, 429: Rebate, 430: Surcharge, 431: Cess
            const tax = parseFloat(r.incomeTax || 0);
            const rebate = parseFloat(r.rebate87A || 0);
            const surcharge = parseFloat(r.surcharge || 0);
            const cess = parseFloat(r.cess || 0);
            r.taxPayable = tax + surcharge + cess - rebate;

            r.netTaxPayable = r.taxPayable - parseFloat(r.relief89 || 0);

            return r;
        });
        onSeniorCitizenDataChange(calculatedData);
    };

    const handleRowAdd = () => {
        const newRow = {
            id: Date.now(),
            seniorCitizenPan: '',
            seniorCitizenName: '',
            category: 'S',
            regime115BAC: 'N',
            grossPension17_1ii: 0,
            ded16ia: 0,
            ded16iii: 0,
            totalDed16: 0,
            salariesIncome: 0,
            interestIncome: 0,
            grossTotalIncome: 0,
            lastGrossTotalIncome: 0,
            ded80C_CCC_CCD1: 0,
            sec80C_Gross: 0, sec80C: 0,
            sec80CCC_Gross: 0, sec80CCC: 0,
            sec80CCD1_Gross: 0, sec80CCD1: 0,
            sec80CCD1B_Gross: 0, sec80CCD1B: 0,
            sec80D_Gross: 0, sec80D: 0,
            sec80E_Gross: 0, sec80E: 0,
            sec80G_Gross: 0, sec80G_Qual: 0, sec80G: 0,
            sec80TTB_Gross: 0, sec80TTB_Qual: 0, sec80TTB: 0,
            sec80DD_Gross: 0, sec80DD_Qual: 0, sec80DD: 0,
            sec80EE_Gross: 0, sec80EE_Qual: 0, sec80EE: 0,
            sec80EEA_Gross: 0, sec80EEA_Qual: 0, sec80EEA: 0,
            sec80GG_Gross: 0, sec80GG_Qual: 0, sec80GG: 0,
            sec80GGC_Gross: 0, sec80GGC_Qual: 0, sec80GGC: 0,
            sec80U_Gross: 0, sec80U_Qual: 0, sec80U: 0,
            secOthers_Gross: 0, secOthers_Qual: 0, secOthers: 0,
            aggChapterVIA: 0,
            totalTaxableIncome: 0,
            incomeTax: 0,
            rebate87A: 0,
            surcharge: 0,
            cess: 0,
            taxPayable: 0,
            relief89: 0,
            netTaxPayable: 0
        };
        onSeniorCitizenDataChange([...(seniorCitizenData || []), newRow]);
    };

    const handleRowDelete = (id) => {
        onSeniorCitizenDataChange((seniorCitizenData || []).filter(row => row.id !== id));
    };

    return (
        <div className="h-[calc(100vh-240px)] w-full max-w-full overflow-hidden">
            <ExcelDataGrid
                columns={columns}
                data={seniorCitizenData || []}
                onDataChange={handleDataChange}
                onRowAdd={handleRowAdd}
                onRowDelete={handleRowDelete}
                height="100%"
                stickyColumns={2}
            />
        </div>
    );
};

export default SeniorCitizens194PTable;
